//import { Link } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';

const Footer = () => {
  return (
    <section className="footer-section" id="footer">
      <div>
        <Link to="/mentions-legal#mentions">MENTION LÉGAL</Link>
        <Link to="/politique-de-confidentialite">
          POLITIQUE DE CONFIDENTIALITÉ
        </Link>
      </div>
      <p>MADE BY <a className="maelcorp" href="https://maelcorp.com/" target="_blank">MAELCORP.</a></p>
    </section>
  );
};

export default Footer;
